import ApiService from "../axios";
import { API_URL } from "../../config";

export const SupplierService = {
  getAll() {
    ApiService.setBaseUrl(API_URL);
    return ApiService.getAll("/api/suppliers");
  },
  get(id) {
    return ApiService.get(`/api/supplier/${id}/get`, id);
  },
  async create(params) {
    return await ApiService.post("/api/supplier/create", params);
  },
  update(params) {
    return ApiService.update("/api/supplier/update", params);
  },
  delete(params) {
    return ApiService.post(`/api/supplier/delete`, params);
  }
};



// WEBPACK FOOTER //
// ./src/http/services/supplier.js